import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ItemService extends GenericService {
  constructor() {
    super('/items', axiosInstance);
  }
}

export default new ItemService(); 